import Depop from "../../assets/images/Header/logo.png";
import Btn_No_Login from "./Btn_No_Login";
import Search_Header from "./Search_Header";
import "./Header.scss";
import Header_Bottom from "./Header_Bottom";
import { HiBars3BottomLeft } from "react-icons/hi2";
import Res_Search_Header from "./Res_Search_Header";
import { getCookie } from "../../helper/cookie";
import { useDispatch, useSelector } from "react-redux";
import Avatar from "./Avatar";
import { loginActions } from "../../actions/login";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DrawerMain from "./DrawerMain";

function Header() {
  const dispatch = useDispatch();
  const token = getCookie("token");
  const isLogin = useSelector((state) => state.loginReducers);
  const navigate = useNavigate();

  // Thêm state để mở/đóng Drawer
  const [openDrawer, setOpenDrawer] = useState(false);

  useEffect(() => {
    if (token) dispatch(loginActions(true));
  }, [dispatch, token]);

  const handleLoad = () => {
    navigate("/");
  };

  return (
    <>
      <header className="header">
        <div className="container-header">
          <div className="header-top">
            {/* Click mở Drawer */}
            <HiBars3BottomLeft
              className="icon-bars"
              onClick={() => setOpenDrawer(true)}
            />

            <div className="img" onClick={handleLoad}>
              <img src={Depop} alt="Depop Logo" />
            </div>

            <Search_Header />

            {isLogin && token ? <Avatar /> : <Btn_No_Login />}
          </div>

          <Res_Search_Header />

          {/* Drawer nhận props từ Header */}
          <DrawerMain open={openDrawer} setOpen={setOpenDrawer} />

          <Header_Bottom />
        </div>
      </header>
    </>
  );
}

export default Header;
